import { FieldType, MagazineNewspaperPublicationField } from '../../../../components/GenericSection/constants';
import { RowType } from '../../../../components/GenericSection/types';
import { END, START } from '../../../constants';
export var NEWSPAPER_PUBINFO_SECTION_FIELDS = [{
  type: FieldType.TEXT,
  labelText: 'Newspaper title',
  field: MagazineNewspaperPublicationField.TITLE
}, {
  field: MagazineNewspaperPublicationField.CITY,
  labelText: 'City',
  type: FieldType.TEXT,
  helperText: 'Only include if city is not in newspaper name'
}, {
  rowtype: RowType.SM_TWO_ROW,
  fields: [{
    field: MagazineNewspaperPublicationField.EDITION,
    labelText: 'Edition',
    type: FieldType.TEXT
  }, {
    field: MagazineNewspaperPublicationField.SECTION,
    labelText: 'Section',
    type: FieldType.TEXT
  }]
}, {
  field: MagazineNewspaperPublicationField.PUBLISHED_DATE,
  type: FieldType.PUBDATE,
  labelText: 'Date published',
  formikFieldNames: ['day', 'month', 'year']
}, {
  fields: [{
    field: MagazineNewspaperPublicationField.START_PAGE,
    labelText: START,
    type: FieldType.TEXT
  }, {
    field: MagazineNewspaperPublicationField.END_PAGE,
    labelText: END,
    type: FieldType.TEXT
  }]
}];